import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=7fa0bd8b"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports